import React = require('react');
import { style } from 'typestyle';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

export const sectionHeader = style({
  fontSize: CommonStyles.Sizes.HeaderFontSize,
  fontWeight: 'bold',
  marginTop: CommonStyles.Sizes.LineHeight,
  borderBottom: `1px solid ${CommonStyles.Colors.Grey245}`,
  paddingBottom: 10,
});

export const buttonStyle = style({
  cursor: 'pointer',
});

export const addButtonStyle = style({
  marginLeft: 15,
});

export const addButtonInfoStyle = style({
  $nest: {
    'img': {
      verticalAlign: 'middle',
    },
  },
});

export const textFieldStyle = style({
  $nest: {
    'input': {
      background: 'white',
    },
  },
});

export const dropDownStyle = style({
  paddingTop: 4,
  paddingRight: 8,
  $nest: {
    'button': {
      background: 'white',
    },
  },
});

export const dataGridContainerStyle = style({
  // Using !important here below causes the grid to size to its contents rather than scrolling
  $nest: {
    '.tb-react-dg-hrow': {
      position: 'inherit !important' as 'inherit',
    },
    '.tb-react-dg-body': {
      position: 'inherit !important' as 'inherit',
    },
    '.tb-react-data-grid': {
      position: 'inherit !important' as 'inherit',
    },
  },
});

export const dataGridBlockContainerStyle = style({
  width: 400,
});

export const dataGridSafeContainerStyle = style({
  width: 800,
});

export const tooltipStyle = style({
  marginLeft: 3,
  verticalAlign: 'text-top',
});

export const dataGridRowHeight = 32;
